import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { fetchBookingDetail } from "../API";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtBtn from "./CustomTool/CtBtn";
import processing from "../gif/processing.gif";
import HoCtToastContainer from "../HOC/HoCtToastContainer";

const BookingDialog = ({ open, onClose, notifyProcessing, closeUpdateProcessing, updateProcessing, toastMsg, toastErrorMsg }) => {
  // TODO: Replace this URL with your actual Google Calendar Appointment Schedule URL
  const googleCalendarUrl = "https://calendar.app.google/it9Zp3eSnBSRkVQDA";

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      toastErrorMsg("Please enter Full Name.");
      document.getElementById('name')?.focus();
      return;
    }

    if (!formData.email.trim()) {
      toastErrorMsg("Please enter Email Address.");
      document.getElementById('email')?.focus();
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toastErrorMsg("Please enter a valid email address.");
      document.getElementById('email')?.focus();
      return;
    }

    if (!formData.phone.trim()) {
      toastErrorMsg("Please enter Phone Number.");
      document.getElementById('phone')?.focus();
      return;
    }

    if (formData.phone.length !== 10) {
      toastErrorMsg("Phone number must be exactly 10 digits.");
      document.getElementById('phone')?.focus();
      return;
    }

    notifyProcessing();

    try {
      const response = await fetchBookingDetail({
        Op: 'SaveBooking',
        vac_customer_name: formData.name,
        vac_email: formData.email,
        vac_phone: formData.phone,
        vac_company_name: formData.company
      });

      const data = response.data;

      if (data.msgType === 'success') {
        updateProcessing("success", data.message || "Details saved successfully!");
        setTimeout(() => {
          setIsSubmitted(true);
        }, 2500);
      } else {
        updateProcessing("error", data.message || "Something went wrong.");
      }
    } catch (error) {
      console.error('Error saving booking details:', error);
      updateProcessing("error", "Failed to connect to the server. Please try again.");
    }
  };

  const handleClose = () => {
    // Reset state when modal is closed so next time it starts fresh
    setIsSubmitted(false);
    setFormData({
      name: "",
      email: "",
      phone: "",
      company: ""
    });
    onClose();
  };

  return (
    <>
      {open && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}>
          <div style={{ backgroundColor: '#fff', borderRadius: 8, padding: 24, width: '100%', maxWidth: isSubmitted ? 800 : 500, height: isSubmitted ? '80vh' : 'auto', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h5" fontWeight={700}>
                {isSubmitted ? "Pick a Time" : "Schedule a Demo"}
              </Typography>
              <CtBtn onClick={handleClose} label="Close" color="inherit" size="small" variant="text" />
            </Box>

            <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
              {!isSubmitted ? (
                <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    Please provide your details below. You will be able to choose a time slot on the next screen.
                  </Typography>

                  <CtTxt
                    id="name"
                    label="Full Name"
                    value={formData.name}
                    handleOnChange={handleInputChange}
                    maxLength={100}
                    variant="outlined"
                    fullWidth
                  />
                  <CtTxt
                    id="email"
                    label="Email Address"
                    value={formData.email}
                    handleOnChange={handleInputChange}
                    maxLength={100}
                    variant="outlined"
                    fullWidth
                  />
                  <CtTxtNum
                    id="phone"
                    label="Phone Number"
                    value={formData.phone}
                    handleOnChange={handleInputChange}
                    maxLength={10}
                    variant="outlined"
                    fullWidth
                  />
                  <CtTxt
                    id="company"
                    label="Company Name (Optional)"
                    value={formData.company}
                    handleOnChange={handleInputChange}
                    maxLength={100}
                    variant="outlined"
                    fullWidth
                  />

                  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <CtBtn onClick={handleClose} label="Cancel" color="inherit" variant="outlined" />
                    <CtBtn
                      onClick={handleSubmit}
                      variant="contained"
                      color="primary"
                      label="Continue to Calendar"
                    />
                  </Box>
                </Box>
              ) : (
                <iframe
                  src={googleCalendarUrl}
                  style={{ border: 0, width: '100%', height: '100%' }}
                  frameBorder="0"
                  title="Google Calendar Appointment Scheduling"
                ></iframe>
              )}
            </Box>
          </div>
        </div>
      )}

    </>
  );
};

export default HoCtToastContainer(BookingDialog);
